import { UsersService } from './../services/users.service';
import { AuthService } from './../services/auth.service';
import { AccountModificationComponent } from './../account-modification/account-modification.component';
import { AccountModificationPwdComponent } from '../account-modification-pwd/account-modification-pwd.component';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { UserInfo } from '../interfaces/user-info';
@Component({
selector: 'app-account-admin',
templateUrl: './account-admin.component.html',
styleUrls: ['./account-admin.component.scss']
})
export class AccountAdminComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;

	id: string = "";
	admin: UserInfo = {
		id: "",
		firstName: "",
		lastName: "",
		fullName: "",
		email: "",
		phone: "",
		userStreet: "",
		userState: "",
		userPostalCode: "",
		userCity: "",
		userCountry: "",
		idOrganization: "",
		nameOrganization: "",
		idRole: "",
		role: "",
		status: "",
		lastConnect: "",
		isActive:  false,
	}

	constructor(
		private accountModalService: NgbModal,
		private toastrService: ToastrService,
		private authService: AuthService,
		private usersService: UsersService
		) { 
		authService.getLoggedInName.subscribe((token) => {
			this.getUserById()
		});
		usersService.getLoggedInName.subscribe((token) => {
			this.getUserById()
		});
		}

	ngOnInit(): void {
		this.getUserById();
	}

	// get user infos by id
	getUserById(): void{
		this.blockUI.start('Loading');

		const token = localStorage.getItem('token');

		this.authService.decodeJWT(token).subscribe(
			(res: any) => {
				if (res.success){
					this.id = res.data.id_user;
					this.usersService.getCoreUserById(this.id).subscribe(
						(res:any) => {
							if(res.success) {
								this.admin = res.data;
								this.blockUI.stop();
							} else {
								this.blockUI.stop();  
								if (res.errorSet.includes('InvalidRequest')) {
									this.toastrService.error('Les paramètres sont invalides');  
								} else if (res.errorSet.includes('NotFound')) {
									this.toastrService.error('Utilisateur non trouvé');  
								}
							}
						},
						(error) => {
							this.blockUI.stop();
							this.toastrService.error('Une erreur s\'est produite');
						}
					);
					this.blockUI.stop();
				} else{
					this.blockUI.stop();
					if (res.errorSet.includes('InvalidRequest')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('TokenError')) {
						this.toastrService.error('Token non trouvé ou invalidé');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
		
	}

	// open modal info modification
	openAccountModification(): void{
		const modalRef = this.accountModalService.open(AccountModificationComponent);
		modalRef.componentInstance.id = this.id;
		modalRef.result.then((result) => {
			this.getUserById();
			// console.log("Closed with:", result);
		}, (reason) => {
			// this.getUserById();
			// console.log(`Dismissed`);
		});
	}

	// open modal password modification
	openAccountModificationPassword():void{
		const modalRef = this.accountModalService.open(AccountModificationPwdComponent);
		modalRef.componentInstance.id = this.id;
	}
}
